import { NavLink, useLocation } from "react-router-dom";
import { useMenu } from "../utils/BurgerMenuContexte.tsx";
import { useState, useEffect } from "react";

import Modal from "./Modal.tsx";

/* import { useAuth } from "../utils/AuthContexte.tsx"; */

const BurgerMenu = () => {
  const { isBurgerMenuOpened, toggleMenu } = useMenu();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [linkHref, setLinkHref] = useState("");
  const location = useLocation();

  /*  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
  }; */

  useEffect(() => {
    // Fermer le menu burger lorsque l'utilisateur navigue vers une autre page
    if (isBurgerMenuOpened) {
      console.log("Fermeture du menu burger");
      toggleMenu();
    }
  }, [location.pathname]);

  // Fonction pour gérer la confirmation avant de quitter la page
  const handleContactClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Empêcher la navigation par défaut
    e.preventDefault();
    setLinkHref(e.currentTarget.href);
    setIsModalOpen(true);
  };

  // Demander la confirmation
  const handleConfirm = () => {
    window.open(linkHref, "_blank");
    setIsModalOpen(false);
    // Fermer le menu burger
    toggleMenu();
  };

  return (
    <>
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleConfirm}
      >
        <h1 className="modal__title">
          Attention ! En cliquant sur ce lien,{" "}
          <span>vous quittez notre site.</span>
        </h1>
        <p className="text-page-light text-page-light--blackSmall">
          Le site web que vous avez demandé à consulter peut contenir des
          infomations sur des produits ou des utilisations de produits qui ne
          sont pas validées en France. D'autre part, les mentions légales du
          site www.cartessurtable-vhc.fr ne s'appliqueront plus. Il faudra vous
          référer aux mentions légales du site en question.
        </p>
      </Modal>
      <div className="nav__hamburger">
        {/* Bouton du menu burger */}
        <button
          className="hamburger"
          onClick={toggleMenu}
          aria-label={`button--burgerMenu`}
        >
          <div
            className={
              isBurgerMenuOpened ? `bar bar--open-1` : "bar bar--closed-1`"
            }
          ></div>
          <div
            className={
              isBurgerMenuOpened ? `bar bar--open-2` : "bar bar--closed-2`"
            }
          ></div>
          <div
            className={
              isBurgerMenuOpened ? `bar bar--open-3` : "bar bar--closed-3`"
            }
          ></div>
        </button>
      </div>
      {/* Contenu du menu, affiché si isBurgerMenuOpened est vrai */}
      <div className={`hamburger__menu`}>
        {/* ${isBurgerMenuOpened && 'hamburger--open'} */}
        <div className="hamburger__menu__list">
          <NavLink to="/accueil" onClick={toggleMenu}>
            Accueil
          </NavLink>
          <NavLink to="/accueil/regles" onClick={toggleMenu}>
            Règles du jeu
          </NavLink>
          <NavLink to="/accueil/references" onClick={toggleMenu}>
            Références
          </NavLink>
          <NavLink to="/accueil/plusinfos" onClick={toggleMenu}>
            Pour aller plus loin
          </NavLink>
          <NavLink
            to="https://privacy.abbvie/privacy-policies/france-privacy-policy.html"
            target="_blank"
            onClick={handleContactClick}
          >
            Confidentialité
          </NavLink>
          <NavLink to="/accueil/mentionslegales" onClick={toggleMenu}>
            Mentions légales
          </NavLink>
          <NavLink
            to="https://www.abbvie.fr/contactus.html"
            target="_blank"
            onClick={handleContactClick}
          >
            Contact
          </NavLink>
          <NavLink to="/accueil/credits" onClick={toggleMenu}>
            Crédits
          </NavLink>

          {/*  <NavLink to="/login" onClick={toggleMenu} style={{ color: "red" }}>
            <p onClick={handleLogout}>Déconnecter</p>
          </NavLink> */}

          <a className="burgerMenu--licence">FR-VHCV-240016 - 09/2024</a>
        </div>
      </div>
    </>
  );
};

export default BurgerMenu;
